import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import AssetAssignmentLayer from '../components/AssetAssignmentLayer';

const AssetAssignmentsPage = () => {
  return (
    <>
      <MasterLayout pageTitle="Asset Assignment">
        <AssetAssignmentLayer />
      </MasterLayout>
    </>
  );
};

export default AssetAssignmentsPage;
